package com.bikompanion.data.rating

import kotlinx.serialization.Serializable
import com.bikompanion.domain.BikeIssue
import com.bikompanion.domain.BikeKey
import com.bikompanion.domain.BikeScopeSource

@Serializable
data class PendingVote(
    val networkId: String,
    val bikeNumber: String,
    val isPositive: Boolean,
    val isElectric: Boolean = false,
    val issues: List<BikeIssue> = emptyList(),
    val scopeSource: BikeScopeSource = BikeScopeSource.ManualPick,
    /** When the rider actually cast it, as opposed to when it eventually reaches the server. */
    val castAtMs: Long,
) {
    val key: BikeKey get() = BikeKey(networkId, bikeNumber)
}
